/* NUDA · aparición al hacer scroll. Sin librerías, sin apps. */
(function () {
  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var sel = '.mt-inner > .mt-h2, .mt-inner > .mt-sub, .mt-step, .mt-rev, .mt-decl__txt, .mt-decl__img, .mt-cmp, .mt-acc, .mt-gar__card, .mt-vcard, .mt-vent__it, .mt-vent__img';

  function collect() {
    return Array.prototype.slice.call(document.querySelectorAll(sel));
  }

  function boot() {
    var els = collect();
    if (!els.length) return;
    if (mq.matches || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-in'); });
      return;
    }
    els.forEach(function (el) { el.classList.add('mt-rv'); });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var group = el.parentElement ? Array.prototype.slice.call(el.parentElement.children).indexOf(el) : 0;
        el.style.transitionDelay = Math.min(group, 5) * 90 + 'ms';
        el.classList.add('mt-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
